import React from "react";

const TextWidget = () => {
  return (
    <React.Fragment>
      <div className="mt-4 pt-2">
        <div className="sd-title">
          <h6 className="fs-16 mb-3">Text Widget</h6>
        </div>
        <p className="mb-0 text-muted mt-3">
          Exercitation photo booth stumptown tote bag Banksy, elit small batch
          freegan sed. Craft beer elit seitan exercitation, photo booth et 8-bit
          kale chips proident chillwave deep v laborum. Aliquip veniam delectus,
          Marfa eiusmod Pinterest in do umami readymade swag.
        </p>
      </div>
    </React.Fragment>
  );
};

export default TextWidget;
